import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const TRACKING_ID = "G-Z7QDDK61JF";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Only initialize and track in production
    if (process.env.NODE_ENV === "production") {
      if (!window.GA_INITIALIZED) {
        ReactGA.initialize(TRACKING_ID);
        window.GA_INITIALIZED = true;
      }
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location]);

  return null;
}